$(function () {
  $('.js-hero-slider').slick({
    arrows: false,
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 10000,
    cssEase: 'linear',
    pauseOnHover: false,
    pauseOnFocus: false,
    swipe: false,
    touchMove: false,
    draggable: false,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
});

$(function () {
  const $toggle = $('.js-ruby-toggle');
  const $content = $('.js-ruby-toggle-content');

  $content.hide();

  $toggle.off('click').on('click', function () {
    const $this = $(this);
    const $targetContent = $this.next('.js-ruby-toggle-content');

    if ($targetContent.length === 0) return;

    $this.toggleClass('ruby-is-open');

    if ($this.hasClass('ruby-is-open')) {
      $targetContent.stop(true, true).slideDown(500);
    } else {
      $targetContent.stop(true, true).slideUp(500);
    }
  });
});

$(function () {
  const $window = $(window);
  const $body = $('body');
  const $header = $('.ruby-js-header');
  const $trigger = $('.ruby-js-header-trigger');
  const isTopPage = $body.hasClass('ruby-top-page');

  $('.ruby-header-openbtn').on('click', function () {
    $(this).toggleClass('ruby-nav-active');
    $('.ruby-header-nav').toggleClass('ruby-nav-panelactive');
  });

  function mediaQueriesWin() {
    const width = $window.width();

    $('.ruby-header-nav-child > a').off('click');

    if (width <= 1024) {
      $('.ruby-header-nav-child > a').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const $parent = $(this).parent();

        $('.ruby-header-nav-child').not($parent)
          .removeClass('ruby-nav-active')
          .children('.ruby-header-nav-child-list')
          .stop(true, true)
          .slideUp(300);

        $parent.toggleClass('ruby-nav-active');
        $parent.children('.ruby-header-nav-child-list')
          .stop(true, true)
          .slideToggle(300);
      });
    } else {
      $('.ruby-header-nav-child')
        .removeClass('ruby-nav-active')
        .children('.ruby-header-nav-child-list')
        .removeAttr('style');

      $('.ruby-header-openbtn').removeClass('ruby-nav-active');
      $('.ruby-header-nav').removeClass('ruby-nav-panelactive');
    }
  }

  function headerScrollClass() {
    if (!$header.length) return;

    const scrollTop = $window.scrollTop();

    if (isTopPage && $trigger.length) {
      const triggerTop = $trigger.offset().top;
      const headerHeight = $header.outerHeight();

      if (scrollTop >= triggerTop - headerHeight) {
        $header.addClass('ruby-is-scrolled');
      } else {
        $header.removeClass('ruby-is-scrolled');
      }
    } else {
      if (scrollTop > 10) {
        $header.addClass('ruby-is-scrolled');
      } else {
        $header.removeClass('ruby-is-scrolled');
      }
    }
  }

  mediaQueriesWin();
  headerScrollClass();

  $window.on('resize', function () {
    mediaQueriesWin();
    headerScrollClass();
  });

  $window.on('scroll', function () {
    headerScrollClass();
  });

  $window.on('load', function () {
    headerScrollClass();
  });
});